module.exports = __webpack_public_path__ + "static/media/TLM-BNB.0543229c.svg";